import React, { Component } from 'react';
import { Modal, Container } from 'react-bootstrap';
import './_attendanceReport.scss';



class MonthlyAttendanceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { monthData = [], empName, empType, empStats } = this.props.stateData || {};

        return (
            <Modal {...this.props}
                size="xl" aria-labelledby="contained-modal-title-vcenter" className='emp_modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Month Wise Data</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {/* Employee Profile Header & Summary Stats */}
                    {empName && (
                        <>
                            <div className="d-flex align-items-center justify-content-between mb-4 p-3" style={{ background: '#fff', borderRadius: '12px', border: '1px solid #cbd5e1', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                                <div className="d-flex align-items-center" style={{ gap: '14px' }}>
                                    <div style={{
                                        width: '46px',
                                        height: '46px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                                        color: '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: '800',
                                        fontSize: '18px',
                                        textTransform: 'uppercase'
                                    }}>
                                        {empName.slice(0, 2)}
                                    </div>
                                    <div className="text-left">
                                        <div style={{ fontSize: '15px', fontWeight: '800', color: '#0f172a' }}>{empName}</div>
                                        <div style={{ fontSize: '11.5px', color: '#64748b', fontWeight: '600', marginTop: '2px' }}>{empType || "Employee"}</div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center" style={{ gap: '20px', flexWrap: 'wrap' }}>
                                    <div className="text-center" style={{ minWidth: '70px' }}>
                                        <div style={{ fontSize: '9px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Total Days</div>
                                        <div style={{ fontSize: '16px', fontWeight: '800', color: '#0f172a', marginTop: '2px' }}>{empStats?.total_days ?? 0}</div>
                                    </div>
                                    <div className="text-center" style={{ minWidth: '70px', borderLeft: '1px solid #cbd5e1', paddingLeft: '20px' }}>
                                        <div style={{ fontSize: '9px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Present</div>
                                        <div style={{ fontSize: '16px', fontWeight: '800', color: '#10b981', marginTop: '2px' }}>{empStats?.present_days ?? 0}</div>
                                    </div>
                                    <div className="text-center" style={{ minWidth: '70px', borderLeft: '1px solid #cbd5e1', paddingLeft: '20px' }}>
                                        <div style={{ fontSize: '9px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Leave</div>
                                        <div style={{ fontSize: '16px', fontWeight: '800', color: '#ef4444', marginTop: '2px' }}>{empStats?.absent_days ?? 0}</div>
                                    </div>
                                    <div className="text-center" style={{ minWidth: '70px', borderLeft: '1px solid #cbd5e1', paddingLeft: '20px' }}>
                                        <div style={{ fontSize: '9px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Half Day</div>
                                        <div style={{ fontSize: '16px', fontWeight: '800', color: '#f59e0b', marginTop: '2px' }}>{empStats?.half_days ?? 0}</div>
                                    </div>
                                    <div className="text-center" style={{ minWidth: '70px', borderLeft: '1px solid #cbd5e1', paddingLeft: '20px' }}>
                                        <div style={{ fontSize: '9px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700', letterSpacing: '0.5px' }}>Percentage</div>
                                        <div style={{ fontSize: '16px', fontWeight: '800', color: '#6366f1', marginTop: '2px' }}>
                                            {empStats?.total_days > 0
                                                ? Math.round(((Number(empStats.present_days || 0) + Number(empStats.half_days || 0) * 0.5) / Number(empStats.total_days)) * 100)
                                                : 0}%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <Container className='table_data' style={{ overflowX: 'auto', paddingBottom: '8px' }}>
                        <table className="mb-0 text-center" style={{ width: 'auto', minWidth: '100%', tableLayout: 'auto', borderCollapse: 'separate' }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        background: '#f1f5f9',
                                        color: '#475569',
                                        fontWeight: '700',
                                        fontSize: '11px',
                                        textTransform: 'uppercase',
                                        padding: '12px 16px',
                                        position: 'sticky',
                                        left: 0,
                                        zIndex: 10,
                                        borderRight: '1.5px solid #cbd5e1',
                                        boxShadow: '2px 0 5px rgba(0,0,0,0.05)'
                                    }}>Date</th>
                                    {
                                        monthData.map((item) => (
                                            <th key={item.date} style={{ fontWeight: '700', fontSize: '11px', padding: '12px 16px', minWidth: '85px', whiteSpace: 'nowrap', textTransform: 'none', letterSpacing: '0' }}>
                                                {item.date}
                                            </th>
                                        ))
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{
                                        background: '#fff',
                                        color: '#475569',
                                        fontWeight: '700',
                                        fontSize: '11px',
                                        textTransform: 'uppercase',
                                        padding: '12px 16px',
                                        position: 'sticky',
                                        left: 0,
                                        zIndex: 10,
                                        borderRight: '1.5px solid #cbd5e1',
                                        boxShadow: '2px 0 5px rgba(0,0,0,0.05)'
                                    }}>Status</td>
                                    {
                                        monthData.map((item) => {
                                            const badgeClass = (item.status === "Present") ? "badge-present" : (item.status === "Absent" || item.status === "Leave") ? "badge-absent" : "badge-blank";
                                            return (
                                                <td key={item.date} style={{ padding: '12px 16px', minWidth: '85px', textAlign: 'center', verticalAlign: 'middle' }}>
                                                    <span className={`ea-modal-status-badge ${badgeClass}`}>{item.status === "Absent" ? "Leave" : item.status}</span>
                                                </td>
                                            );
                                        })
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </Container>
                </Modal.Body>
                <Modal.Footer variant="white" className="px-4">

                </Modal.Footer>
            </Modal >
        )
    }
}

export default (MonthlyAttendanceModal);